import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 19.5l-5 -2.5l-6 3v-13l6 -3l6 3l6 -3v9","key":"svg-0"}],["path",{"d":"M9 4v13","key":"svg-1"}],["path",{"d":"M15 7v6.5","key":"svg-2"}],["path",{"d":"M22 22l-5 -5","key":"svg-3"}],["path",{"d":"M17 22l5 -5","key":"svg-4"}]]

const IconMapX = createReactComponent('outline', 'map-x', 'MapX', __iconNode);

export default IconMapX;